// if there is no valid thumbnail url, show message stating as such
import { Trans } from '@lingui/macro';
import * as React from 'react';

import { AssetsResponseObject } from '@api/v4/assets/assetTypes';
import { BoardResponseObject } from '@api/v4/boards/boardsTypes';

// copied from card.jsx
const handleThumbnailError = ({ event, resource }): void => {
  // Hacky, but don't want to implement state unless necessary
  const { extension, name } = resource.attributes;
  const modifiedExtension = extension ? extension.replace('.', '') : '-';
  const source = (modifiedExtension) ? `${modifiedExtension}.svg` : 'file.svg';
  event.target.src = `${BFG.icon_service_url}/assets/types/${source}`;
  event.target.alt = name; // eslint-disable-line no-param-reassign
  event.target.style.cssText = 'padding: 25px;'; // eslint-disable-line no-param-reassign
};

interface AssetBoardCardThumbnailProps {
  resource: BoardResponseObject | AssetsResponseObject;
  setShowOverlay: SetStateDispatch<boolean>;
}

const AssetBoardCardThumbnail: React.FunctionComponent<AssetBoardCardThumbnailProps> = ({
  children,
  resource,
  setShowOverlay
}) => {
  const containerRef = React.useRef<HTMLDivElement>(null);

  const handleBlur = (e: React.FocusEvent<HTMLDivElement>): void => {
    const related = e.relatedTarget;
    if (!containerRef.current) return;

    // relatedTarget is the element receiving focus; available synchronously on blur.
    if (related instanceof Node && containerRef.current.contains(related)) return;

    if (related instanceof Element) {
      if (
        related.closest('.board-action-overlay') ||
        related.closest('.content-container, .anchor-element-click-container, .asset-card-actions')
      ) {
        return;
      }
    }

    setShowOverlay(false);
  };

  return (
    <div
      ref={containerRef}
      className="thumbnail-container"
      tabIndex={0}
      role="button"
      aria-label={resource.attributes.name || 'Board card'}
      onMouseEnter={(): void => setShowOverlay(true)}
      onMouseLeave={(): void => setShowOverlay(false)}
      onFocus={(): void => setShowOverlay(true)}
      onBlur={handleBlur}
    >
    {children}
    {resource.attributes.thumbnail_url ? (
      <div className="thumbnail">
        <img
          onError={(event): void => { handleThumbnailError({ event, resource }); }}
          src={resource.attributes.thumbnail_url}
          alt=""
        />
      </div>
    ) : (
      <div className="no-thumbnail">
        <span>
          <Trans>This board has no assets.</Trans>
        </span>
      </div>
    )}
    </div>
  );
};

export default AssetBoardCardThumbnail;
